export const auth = {
  authHomeTitle: 'Zaczynamy',
  authHomeButtonBranded: 'Kontynuuj przez E-mail',
  authHomeButtonApple: 'Kontynuuj przez Apple',
  authHomeButtonGoogle: 'Kontynuuj przez Google',
  authHomeButtonFacebook: 'Kontynuuj przez Facebook',
  authHomeButtonLinkedin: 'Kontynuuj przez LinkedIn',
  authStartTitle: 'Zaloguj się lub Zarejestruj',
  authStartInputTitle: 'E-mail',
  authStartInputTitleError: 'Wprowadź poprawny adres e-mail!',
  authStartInputPasswordError: 'Wprowadź poprawne hasło!',
  authWhoops: 'Ups!',
  authStartConfirmButton: 'Kontynuuj',
  authRegisteredTitle: 'Witaj ponownie!',
  authStartPlaceholderTitle: 'E-mail',
  authRegisteredInputTitle: 'Hasło',
  authRegisteredForgotPassword: 'Zapomniałeś hasła',
  authAlertIncorrectPassword: 'Twój adres e-mail lub hasło jest nieprawidłowe',
  authAlertRequiredPassword: 'Wprowadź poprawne hasło',
  authFinishSignUpTitle: 'Zakończ Rejestrację',
  authFinishSignUpEmailInputTitle: 'E-mail',
  authFinishSignUpFirstNameInputTitle: 'Imię',
  authFinishSignUpLastNameInputTitle: 'Nazwisko',
  authFinishSignUpPasswordInputTitle: 'Hasło',
  authFinishSignUpTipContent:
    '<ul class="text-14 pl-4 text-black"><li class="-ml-4 list-none">Zalecamy używanie:</li><li class="list-disc">Co najmniej 8 znaków</li><li class="list-disc">Zawarcie 1 cyfry</li><li class="list-disc">Zawarcie 1 znaku specjalnego</li></ul>',
  authFinishSignUpPrivacyAndTerms: {
    text1: 'Klikając Zarejestruj, akceptujesz naszą',
    privacyPolicy: 'Politykę prywatności',
    text2: 'oraz',
    termsOfUse: 'Warunki korzystania'
  },
  authFinishSignUpConfirmButton: 'Zarejestruj się',
  authFinishSignUpErrorFirstName: 'Imię nie może być puste!',
  authFinishSignUpErrorLastName: 'Nazwisko nie może być puste!',
  authFinishSignUpErrorPassword: 'Hasło jest za krótkie!',
  authEmailConfirmationTitle: 'Sprawdź swoją skrzynkę pocztową',
  authEmailConfirmationContent:
    'Wysłaliśmy e-mail z potwierdzeniem, aby zweryfikować Twój adres e-mail. Upewnij się również, że sprawdzisz swój folder spamowy, jeśli nie znajdziesz go w swojej skrzynce odbiorczej.',
  authEmailConfirmationConfirmButton: 'Powrót do logowania',
  authAlertEmailConfirmation: 'Sprawdź swoją skrzynkę odbiorczą, aby potwierdzić swój adres e-mail!',
  authResetPasswordTitle: 'Sprawdź swoją skrzynkę pocztową',
  authResetPasswordDescription:
    'Wysłaliśmy link do resetowania hasła na Twój adres e-mail. Upewnij się również, że sprawdzisz swój folder spamowy, jeśli nie znajdziesz go w swojej skrzynce odbiorczej.',
  authResetPasswordButton: 'Powrót do logowania',
  authNewPasswordTitle: 'Wprowadź nowe hasło',
  authNewPasswordInputTitle: 'Nowe hasło',
  authNewPasswordButton: 'Resetuj hasło',
  authNewPasswordAlertValidation: 'Twoje hasło nie jest wystarczająco silne',
  authPasswordChangeSuccessTitle: 'Hasło zmienione!',
  authPasswordChangeSuccessContent: 'Twoje hasło zostało pomyślnie zmienione!',
  authPasswordChangeSuccessButton: 'Powrót do logowania',
  authPasswordChangeErrorTitle: 'Błąd!',
  authPasswordChangeErrorContent: 'Wystąpił problem podczas próby zresetowania hasła! Spróbuj ponownie później.',
  authPasswordChangeErrorButton: 'Powrót do logowania',
  authInvitationTitle: 'Wybierz hasło',
  authInvitationInputTitle: 'Hasło',
  authInvitationButton: 'Ustaw hasło',
  authEmailAddressConfirmed: 'Adres e-mail potwierdzony!'
}
